import { render, staticRenderFns } from "./infoCom.vue?vue&type=template&id=4e95ed84"
import script from "./infoCom.vue?vue&type=script&lang=js"
export * from "./infoCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e95ed84')) {
      api.createRecord('4e95ed84', component.options)
    } else {
      api.reload('4e95ed84', component.options)
    }
    module.hot.accept("./infoCom.vue?vue&type=template&id=4e95ed84", function () {
      api.rerender('4e95ed84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/leftTopCom/infoCom.vue"
export default component.exports